<template>
  <div class="products por ova" :class="{ en: $i18n.locale === 'en-US' }">
    <!-- 浮动导航 -->
    <div class="nav-wrapper" :class="{ fixed: navFixed }">
      <div class="nav-content">
        <ul class="nav-list flex column justify-center">
          <li
            v-for="(group, index) in products"
            :key="index"
            class="nav-item flex items-center cursor-pointer"
            :class="{ active: activeGroupIndex === index }"
            @click="scrollToGroup(index)"
          >
            <p class="nav-index">{{ group.index }}</p>
            <p class="nav-title">{{ group.title }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 内容 -->
    <div id="product-content" class="content ova">
      <div
        class="title-wrapper text-center wow animate__animated animate__fadeInUp"
      >
        <p class="section-title text-bold">{{ $t("home.products.title") }}</p>
      </div>
      <div class="content-main wow animate__animated animate__fadeInUp">
        <div
          v-for="group in products"
          :key="group.index"
          :id="'product-group-' + group.index"
          class="product-group"
        >
          <div class="group-title-wrapper text-center">
            <p class="group-index">{{ group.index }}</p>
            <p
              class="group-title section-title pre-wrap"
              v-text="group.title"
            ></p>
            <p class="group-subtitle section-subtitle">
              {{ group.subtitle }}
            </p>
          </div>
          <div class="product-list flex item-center">
            <div
              class="product-item flex column justify-between ovh"
              v-for="(item, index) in group.list"
              :key="index"
              :style="`background-image: url(${item.img})`"
            >
              <div
                class="item-title-wrapper text-center flex column justify-center items-center"
              >
                <p class="item-title section-title" v-html="item.title"></p>
                <p class="item-subtitle section-subtitle">
                  {{ item.subtitle }}
                </p>
              </div>
              <div
                class="item-more flex justify-center items-center"
                :class="{
                  'with-detail': !!item.detail,
                }"
              >
                <p v-if="!!item.detail" class="detail text-ellipsis2">
                  {{ item.detail }}
                </p>
                <router-link
                  class="more-link flex justify-between items-center"
                  :to="{
                    path: item.path,
                  }"
                >
                  <span>{{ $t("home.common.more") }}</span>
                  <span class="el-icon-arrow-right" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PDGaiABg from "@/static/img/home/product-PDGaiA-bg.webp";
import PDRobotBg from "@/static/img/home/product-PDRobot-bg.webp";
import PDUranusBg from "@/static/img/home/product-PDUranus-bg.webp";
import OnCloudBg from "@/static/img/home/product-OnCloud-bg.webp";
import PDRHeaBg from "@/static/img/home/product-PDRHea-bg.webp";
import PlenRayBg from "@/static/img/home/product-PlenRay-bg.webp";
import PDDiLBg from "@/static/img/home/product-PDDiL-bg.webp";
import MedusaBg from "@/static/img/home/product-Medusa-bg.webp";
import HerculesBg from "@/static/img/home/product-Hercules-bg.webp";

export default {
  data() {
    return {
      activeGroupIndex: 0,
      navFixed: false,
    };
  },
  computed: {
    products() {
      const config = [
        [
          {
            bg: PDGaiABg,
            path: "/productGaiA",
          },
          {
            bg: PDRobotBg,
            path: "/productRobot",
          },
          {
            bg: PDUranusBg,
            path: "/productUranus",
          },
        ],
        [
          {
            bg: OnCloudBg,
            path: "/productClound",
          },
          {
            bg: PDRHeaBg,
            path: "/productRHea",
          },
          {
            bg: PlenRayBg,
            path: "/coretechnology",
          },
        ],
        [
          {
            bg: PDDiLBg,
            path: "/productRing",
          },
          {
            bg: MedusaBg,
            path: "/productMedusa",
          },
          {
            bg: HerculesBg,
            path: "/productHercules",
          },
        ],
      ];
      return this.$t("home.products")?.groups?.map((group, index) => {
        return {
          ...group,
          index: (index + 1).toString().padStart(2, "0"),
          list: group.list.map((item, subIndex) => ({
            ...item,
            img: config[index][subIndex].bg,
            path: config[index][subIndex].path,
          })),
        };
      });
    },
  },
  methods: {
    handleScroll() {
      const groups = document.querySelectorAll(".product-group");
      const scrollTop = window.scrollY || window.pageYOffset;
      let activeIndex = 0;
      groups.forEach((group, idx) => {
        const rect = group.getBoundingClientRect();
        const offsetTop = rect.top + scrollTop;
        if (scrollTop + 200 >= offsetTop) {
          // 200 可根据实际调整
          activeIndex = idx;
        }
      });
      this.activeGroupIndex = activeIndex;

      const content = document.querySelector("#product-content");
      const contentRect = content.getBoundingClientRect();
      const nav = document.querySelector(".products .nav-wrapper");
      const navRect = nav.getBoundingClientRect();
      this.navFixed =
        contentRect.top < 0 &&
        contentRect.top + contentRect.height > navRect.height;
    },
    scrollToGroup(index) {
      const group = document.getElementById(
        "product-group-" + this.products[index].index
      );
      if (group) {
        group.scrollIntoView({
          behavior: "smooth",
        });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll(); // 初始化
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.products {
  // 浮动导航
  .nav-wrapper {
    position: absolute;
    top: 2rem;
    left: 2rem;
    width: 7.625rem;
    z-index: 10;
    .nav-content {
      width: 100%;
      padding: 0.933rem 0;
      .nav-list {
        gap: 1.25rem;
        .nav-item {
          font-family: "Roboto Condensed";
          font-size: 0.6875rem;
          font-weight: 400;
          color: white;
          opacity: 0.45;
          gap: 0.375rem;
          padding-bottom: 0.5rem;
          border-bottom: 0.125rem solid transparent;
          &.active {
            color: var(--hightlight-color);
            border-color: var(--hightlight-color);
            opacity: 1;
          }
        }
        .nav-index {
          font-size: 2rem;
        }
      }
    }
    &.fixed {
      position: fixed;
      top: 6rem;
    }
  }
  // 内容
  .content {
    width: 100%;
    .title-wrapper {
      width: 100%;
      padding: 2.24rem 0;
      margin: 0 auto;
      background: url("@/static/img/home/product-header-bg.webp") no-repeat;
      background-size: cover;
      .section-title {
        margin-bottom: 1rem;
      }
    }
    .content-main {
      background: url("@/static/img/home/product-section-1-bg.webp") no-repeat;
      background-size: 100%;
      .product-group {
        width: 100%;
        padding: 2.6rem 0 4.95rem;
        .group-title-wrapper {
          // width: 56rem;
          width: 70rem;
          margin: 0 auto 2.8rem;
          .group-index {
            font-family: "Roboto Condensed";
            font-size: 10rem;
            font-weight: bold;
            line-height: 0.8;
            color: #373e71;
            opacity: 0.4;
          }
          .group-title {
            margin-top: -3.36rem;
            position: relative;
            z-index: 2;
            line-height: normal;
          }
        }
        .product-list {
          width: 71.841rem;
          height: 30.789rem;
          margin: 0 auto;
          gap: 1.5rem;
          .product-item {
            width: 19.625rem;
            background-size: cover;
            background-position: center;
            color: #fff;
            border-radius: 0.25rem;
            border: 0.0625rem solid #272627;
            box-shadow: 1rem 1.5rem 2.5rem 0 rgba(5, 3, 36, 0.4);
            backdrop-filter: blur(0.933rem);
            transition: all 0.5s ease;
            .item-title-wrapper {
              height: 3.45rem;
              padding: 0.28rem 1.12rem;
              background: rgba(47, 83, 125, 0.3);
              backdrop-filter: blur(0.625rem);
              transition: all 0.5s ease;
              .item-title {
                transition: all 0.5s ease;
                font-size: 0.875rem;
                line-height: 1.8;
              }
              .item-subtitle {
                transition: all 0.5s ease;
                display: none;
                line-height: 1.625rem;
              }
            }
            .item-more {
              width: 27.5rem;
              padding: 0.75rem 1rem;
              margin: 0 auto 1.12rem;
              border-radius: 0.125rem;
              transform: translateY(calc(100% + 3.36rem));
              gap: 1.5rem;
              color: white;
              transition: all 0.5s ease;
              &.with-detail {
                background: rgba(66, 100, 140, 0.3);
                backdrop-filter: blur(0.625rem);
              }
              .detail {
                font-size: 0.75rem;
                line-height: 2;
              }
              .more-link {
                min-width: 8.84rem;
                height: 2.73rem;
                padding: 0 1.5rem;
                font-size: 0.875rem;
                border-radius: 1.375rem;
                border: 0.0625rem solid rgba(255, 255, 255, 0.4);
                background: rgba(30, 44, 80, 0.18);
                box-shadow: 0 0.12rem 0.75rem 0 rgba(30, 44, 80, 0.18),
                  0 0 0 0.0625rem rgba(255, 255, 255, 0.08) inset;
                backdrop-filter: blur(0.5rem);
                transition: background 0.2s, box-shadow 0.2s, border 0.2s;
                color: inherit;
                &:hover {
                  background: rgba(30, 44, 80, 0.32);
                  // border: 0.1rem solid rgba(255, 255, 255, 0.7);
                  box-shadow: 0 0.25rem 1.5rem 0 rgba(30, 44, 80, 0.28),
                    0 0 0 2px rgba(255, 255, 255, 0.15) inset;
                }

                .el-icon-arrow-right {
                  margin-left: 0.65rem;
                  font-size: 1.12rem;
                }
              }
            }
            &:first-child:not(:has(~ :hover)),
            &:hover {
              width: 30rem;
              // background-size: 140%;
              .item-title-wrapper {
                width: 100%;
                margin: 3.4375rem auto 0;
                background: none;
                backdrop-filter: none;
                padding-left: 2.8rem;
                padding-right: 2.8rem;
                .item-title {
                  font-size: 1.25rem;
                }
                .item-subtitle {
                  display: block;
                }
              }
              .item-more {
                transform: translateY(0);
              }
            }
          }
        }
        &:nth-child(3) {
          background: url("@/static/img/home/product-section-3-bg.webp")
            no-repeat;
          background-size: 100%;
        }
      }
    }
  }

  &.en {
    .content {
      .content-main {
        .product-group {
          .product-list {
            .product-item {
              .item-title-wrapper {
                .item-title {
                  font-size: 0.75rem;
                  line-height: 1.5;
                }
                .item-subtitle {
                  line-height: 1.5;
                  font-size: 0.675rem;
                }
              }
              .item-more {
                .more-link {
                  padding: 0 1rem;
                }
              }
              &:first-child:not(:has(~ :hover)),
              &:hover {
                .item-title-wrapper {
                  .item-title {
                    font-size: 1.1rem;
                    margin-bottom: 1rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
